import { CapsuleCollider, RigidBody } from "@react-three/rapier";
import Character from "./Character";
import CameraController from "./CameraController";
import MovementController from "./MovementController";
import { useRef, useEffect, useState } from "react";
import useGame from "./stores/useGame";

export default function CharacterController({ onBookCollision }) {
    const rb = useRef();
    const container = useRef();
    const character = useRef();
    const actions = useRef({});
    const [currentAction, setCurrentAction] = useState('iddle'); // Default action

    const reset = () => {
        if (rb.current) {
            rb.current.setTranslation({ x: 0, y: 1, z: -1 });
            rb.current.setLinvel({ x: 0, y: 0, z: 0 });
            rb.current.setAngvel({ x: 0, y: 0, z: 0 });
        }
    };

    useEffect(() => {
        useGame.subscribe(
            (state) => state.phase,
            (value) => {
                if (value === "ready") {
                    reset();
                }
            }
        );
    }, []);

    const handleCollisionEnter = ({ target, other }) => {
        const otherData = other.rigidBodyObject.userData;
        if (otherData && otherData.type === 'book' && !otherData.collected) {
            otherData.collected = true; // Marcar como recogido
            onBookCollision(otherData.index);
        }
    };

    return (
        <>
            <RigidBody ref={rb} colliders={false} lockRotations onCollisionEnter={handleCollisionEnter}>
                <group ref={container}>
                    <group ref={character}>
                        <Character actions={actions.current} currentAction={currentAction} />
                    </group>
                </group>
                <CapsuleCollider args={[0.35, 0.5]} />
            </RigidBody>
            <CameraController rb={rb} />
            <MovementController rb={rb} character={character} setCurrentAction={setCurrentAction} actions={actions.current} />
        </>
    );
}
